import { DateTime } from "luxon";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgButton } from "@intelligems/ig-theme";
import { OrganizationDto } from "@intelligems/ig-types";

import { useGetOrg } from "../../../api/organizations/get-organization";
import { SETTINGS_ROUTES } from "../../../routes/routes";
import { dismissAlert } from "../../../store/slices/appSettings";
import { getRemainingTrialDays } from "../../Utils/helpers";
import { IgInfo } from "../../Utils/IgInfo";

interface FreeTrialAlertProps {
  org: OrganizationDto;
}

const FreeTrialStatusAlert = ({ org }: FreeTrialAlertProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const remainingTrialDays = getRemainingTrialDays(
    org.freeTrialExpiresAtTs,
    org.createdAtTs
  );

  if (
    !org.organizationSubscriptions.find(
      (sub) => sub.subscriptionStatus === "active"
    )
  ) {
    return (
      <IgInfo
        dismissId={"free-trial-pending"}
        title={"Activate your plan"}
        message={
          remainingTrialDays > 0
            ? `You have ${remainingTrialDays} ${
                remainingTrialDays !== 1 ? "days" : "day"
              } left in your free trial.`
            : `Your free trial has expired`
        }
        severity={remainingTrialDays > 0 ? "info" : "warning"}
        buttons={[
          <IgButton
            variant={"contained"}
            onClick={() => {
              navigate(SETTINGS_ROUTES.Settings);
              dispatch(
                dismissAlert({
                  orgId: org.id,
                  alertId: "free-trial-pending",
                })
              );
            }}
          >
            Activate
          </IgButton>,
        ]}
      />
    );
  } else if (
    org.organizationSubscriptions.find(
      (sub) => sub.subscriptionStatus === "active"
    ) &&
    remainingTrialDays
  ) {
    return (
      <IgInfo
        dismissId={"free-trial-active"}
        message={`You have ${remainingTrialDays} ${
          remainingTrialDays !== 1 ? "days" : "day"
        } left in your free trial.`}
        severity={remainingTrialDays > 0 ? "info" : "warning"}
      />
    );
  }
  return null;
};

export const FreeTrialAlert = () => {
  const org = useGetOrg();

  if (org.data) {
    return <FreeTrialStatusAlert org={org.data.org} />;
  }
  return null;
};
